// 簡易セマンティックバージョン比較（major.minor.patch のみ対応、suffix 等は無視）
// a < b なら -1、a === b なら 0、a > b なら 1 を返す
export function compareVersion(a: string, b: string): -1 | 0 | 1 {
  const pa = a.split('.').map((n) => Number(n) || 0);
  const pb = b.split('.').map((n) => Number(n) || 0);
  for (let i = 0; i < 3; i++) {
    const da = pa[i] ?? 0;
    const db = pb[i] ?? 0;
    if (da < db) return -1;
    if (da > db) return 1;
  }
  return 0;
}

// Viewer がフルサポートする SitemapResult スキーマのバージョン。
// このバージョンより古い JSON が読み込まれたら、Header で控えめに案内する。
export const VIEWER_SUPPORTED_SCHEMA = '1.2.0';
